import { createSlice } from "@reduxjs/toolkit";
import axios from "../../shared/api/axios";
// ----------------------------------------------------------------------

const initialState = {
  isAuth: true,
  isAuthProcess: true,
  errorMessage: null,
  profile: {
    limits: {
      min: 50,
      max: 1000000,
    },
  },
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signIn(state, action) {
      state.isAuthProcess = true;
    },
    signInSuccess(state, action) {
      state.isAuthProcess = false;
      state.isAuth = action.payload;
    },
    profileSuccess(state, action) {
      state.profile = action.payload;
    },
    signInFail(state, action) {
      state.isAuthProcess = false;
      state.errorMessage = action.payload;
    },
    setError(state, action) {
      state.errorMessage = action.payload;
    },
    logout() {
      return initialState;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  signIn,
  signInSuccess,
  profileSuccess,
  signInFail,
  setError,
  logout,
} = slice.actions;

// ----------------------------------------------------------------------
export function getProfile() {
  return async (dispatch) => {
    try {
      const response = await axios.get("/api/v1/keno/profile");
      dispatch(slice.actions.profileSuccess(response.data));
    } catch (error) {
      const errorMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.errorMessage ||
        error?.message;
      dispatch(slice.actions.setError(errorMessage));
    }
  };
}
